export const isConnected = ({ network }) => {
  if (global.platform === 'web') return true;
  return network?.isConnected;
};
